import React from 'react'
import './insightTestimonials.scss';

function Testimonials({ description, author, designation }) {

    return (
        <div className="testimonials-container">
            <div className='testimonial-text'>
                {description}
            </div>
            <div className="author-wrapper">
                <div className='author-name-style'>{author}</div>
                <div className='author-designation-style'>{designation}</div>
            </div>
        </div>
    );
}

export default React.memo(Testimonials);